
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/checklist-library/[slug]",
      function () {
        return require("private-next-pages/resources/checklist-library/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/checklist-library/[slug]"])
      });
    }
  